import { useDebounceFn } from 'ahooks';
import { DebounceOptions } from 'ahooks/es/useDebounce/debounceOptions';

const defaultConfig = {
  wait: 200,
  leading: true,
  trailing: false,
};

const useFn = (
  fn: (...arg: any) => any,
  options: DebounceOptions = defaultConfig,
) => {
  const { run } = useDebounceFn(fn, {
    ...defaultConfig,
    ...options,
  });
  return run;
};

export default useFn;
